export const filterDefaultData = {
  languageId: 1,
  programId: 1,
  courseId: '',
  courseTypeId: 0,
  countryId: 0,
  cityId: '',
  accommodationId: 0,
  accommodationType: 'none',
  accommodationBedroomType: null,
  weekRange: 2,
  category: '',
  updateFilter: true,
};
